export default __webpack_public_path__ + "static/media/phone-number-input.ca2161a0.svg";